import React from 'react';
import { Link } from 'react-router-dom';
import ErrorLayout from '../components/ErrorLayout';
import { useCommonTranslation } from '../../../hooks';

const Error503 = () => {
  const { t } = useCommonTranslation();

  return (
    <ErrorLayout
      code={503}
      title={t('errorPages.503.title')}
      message={t('errorPages.503.message')}
      action={
        <Link to="/" className="px-4 py-2 rounded-lg text-white" style={{ backgroundColor: '#1E40AF' }}>
          {t('errorPages.503.goHome')}
        </Link>
      }
    />
  );
};

export default Error503;
